import { Nav, Button, Collapse, NavItem } from "react-bootstrap";
import { House, Calendar, User, Stethoscope, Printer, LogOut, Menu, Settings, ChevronDown, KeyRound, FileText, Bell  } from "lucide-react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function Sidebar({ onSelect, isOpen, toggleSidebar }) {

    const navigate = useNavigate();
    const location = useLocation();

    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [isUserAdmin, setIsUserAdmin] = useState(false);

    useEffect(() => {
        const storedRoles = JSON.parse(sessionStorage.getItem('roles'));
        if(storedRoles){
            setIsUserAdmin(storedRoles.includes('ADMIN'));
        } else {
            setIsUserAdmin(false);
        }
    }, []);


    return (
        <div
            className="d-flex flex-column vh-100 shadow-sm position-relative bg-light"
            style={{
                width: isOpen ? "220px" : "60px",
                transition: "width 0.3s",
            }}
        >
            {/* Botão de toggle */}
            <Button
                variant="light"
                size="sm"
                onClick={toggleSidebar}
                style={{
                    backgroundColor: "#e6f2ff",
                    position: "absolute",
                    top: 10,
                    left: 10,
                    zIndex: 10,
                }}
            >
                <Menu size={20} />
            </Button>

            {/* Título */}
            <div className="text-center py-3 fw-bold mt-5">
                {isOpen ? "" : ""}
            </div>

            {/* Menu */}
            <Nav className="flex-column px-2 mt-3"
                variant="pills"
                activeKey={location.pathname}>
                <Nav.Item>
                    <Nav.Link
                        eventKey="/home"
                        onClick={() => navigate("/home")}
                        className="d-flex align-items-center gap-2 text-dark"
                    >
                        <House size={20} />
                        {isOpen && "Início"}
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                    <Nav.Link
                        eventKey="/agenda"
                        onClick={() => navigate("/agenda")}
                        className="d-flex align-items-center gap-2 text-dark"
                    >
                        <Calendar size={20} />
                        {isOpen && "Agenda"}
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                    <Nav.Link
                        eventKey="/patient-list"
                        onClick={() => navigate("/patient-list")}
                        className="d-flex align-items-center gap-2 text-dark"
                    >
                        <User size={20} />
                        {isOpen && "Paciente"}
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                    <Nav.Link
                        eventKey="/dentist"
                        onClick={() => navigate("/dentist")}
                        className="d-flex align-items-center gap-2 text-dark"
                    >
                        <Stethoscope size={20} />
                        {isOpen && "Dentista"}
                    </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                    <Nav.Link
                        eventKey="impressoes"
                        onClick={() => setIsSettingsOpen(!isSettingsOpen)}
                        aria-controls="settings-collapse"
                        aria-expanded={isSettingsOpen}
                        className="d-flex align-items-center gap-2 text-dark"
                        style={{ cursor: 'pointer' }}
                    >
                        <Settings size={20} />
                        {isOpen && (
                            <span className="d-flex justify-content-between w-100 align-items-center">
                                Configurações
                                <ChevronDown
                                    size={16}
                                    style={{
                                        transform: isSettingsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.2s',
                                        color: '#6c757d'
                                    }}
                                />
                            </span>
                        )}
                    </Nav.Link>
                </Nav.Item>

                <Collapse in={isOpen && isSettingsOpen}>
                    <div id="settings-collapse">
                        <Nav.Item>
                            <Nav.Link
                                eventKey="/print-settings"
                                onClick={() => navigate("/print-settings")}
                                className="d-flex align-items-center gap-2 text-dark ms-3"
                            >
                                <Printer size={20} />
                                {isOpen && "Impressões"}
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link
                                eventKey="/change-password"
                                onClick={() => navigate("/change-password")}
                                className="d-flex align-items-center gap-2 text-dark ms-3"
                            >
                                <KeyRound size={20} />
                                {isOpen && "Alterar Senha"}
                            </Nav.Link>
                        </Nav.Item>
                        <NavItem>
                            <Nav.Link
                                eventKey="/terms"
                                onClick={() => navigate("/terms")}
                                className="d-flex align-items-center gap-2 text-dark ms-3"
                            >
                                <FileText size={20} />
                                {isOpen && "Termos"}
                            </Nav.Link>
                        </NavItem>
                        {isUserAdmin && (
                            <Nav.Item>
                                <Nav.Link
                                    eventKey="/settings/notifications"
                                    onClick={() => navigate("/settings/notifications")}
                                    className="d-flex align-items-center gap-2 text-dark ms-3"
                                >
                                    <Bell size={20} />
                                    {isOpen && "Notificações"}
                                </Nav.Link>
                            </Nav.Item>
                        )}
                    </div>
                </Collapse>
            </Nav>

            <div className="mt-auto px-2 mb-3">
                <Nav.Item>
                    <Nav.Link
                        eventKey="logout"
                        onClick={() => navigate("/login")}
                        className="d-flex align-items-center gap-2 text-danger"
                    >
                        <LogOut size={20} />
                        {isOpen && "Sair"}
                    </Nav.Link>
                </Nav.Item>
            </div>
        </div>
    );
}
